/* The brand sunburst as a route selector: twenty rays, four per route, and
   the chosen route's sector lit. Purely decorative; the tabs carry meaning. */
const C = 170;
const RAYS = 20;
const PER_ROUTE = 4;

const rays = Array.from({ length: RAYS }, (_, i) => {
  const angle = i * (360 / RAYS);
  const long = i % PER_ROUTE === 0;
  const end = long ? 24 : i % 2 === 0 ? 36 : 48;
  return { i, angle, end, long };
});

/** Where each route's tag sits around the dial, in % of the box. */
export const ROUTE_TAG_POSITIONS = [0, 1, 2, 3, 4].map((k) => {
  const rad = ((-90 + k * 72) * Math.PI) / 180;
  return { left: 50 + 45 * Math.cos(rad), top: 50 + 45 * Math.sin(rad) };
});

export function RouteDial({ active, centerLabel }: { active: number; centerLabel: string }) {
  return (
    <svg viewBox="0 0 340 340" aria-hidden="true" className="absolute inset-[9%] h-[82%] w-[82%] overflow-visible">
      <defs>
        <radialGradient id="route-dial-pool" cx="50%" cy="50%" r="50%">
          <stop offset="0" stopColor="rgb(114 181 177 / 0.3)" />
          <stop offset="1" stopColor="rgb(114 181 177 / 0)" />
        </radialGradient>
      </defs>
      <circle cx={C} cy={C} r={165} fill="url(#route-dial-pool)" />
      <g strokeLinecap="round">
        {rays.map((ray) => {
          const sector = Math.floor(ray.i / PER_ROUTE);
          const lit = sector === active;
          const head = lit && ray.long;
          return (
            <line
              key={ray.i}
              x1={C}
              y1={C - 64}
              x2={C}
              y2={ray.end}
              transform={`rotate(${ray.angle} ${C} ${C})`}
              stroke={head ? "#72b5b1" : lit ? "rgb(114 181 177 / 0.7)" : "rgb(255 255 255 / 0.13)"}
              strokeWidth={head ? 12 : ray.long ? 10 : 8}
              style={{ transition: "stroke 500ms cubic-bezier(0.16, 1, 0.3, 1)", transitionDelay: lit ? `${(ray.i % PER_ROUTE) * 60}ms` : "0ms" }}
            />
          );
        })}
      </g>
      <circle cx={C} cy={C} r={56} fill="#122c46" stroke="#72b5b1" strokeWidth={2} />
      <text
        x={C}
        y={C}
        textAnchor="middle"
        dominantBaseline="central"
        fill="#fff"
        style={{ fontFamily: "var(--font-display)", fontSize: 17, fontWeight: 600 }}
      >
        {centerLabel}
      </text>
    </svg>
  );
}
